import React, { useState, useEffect } from 'react'
import { Col, Card, Row } from 'react-bootstrap'
import DateRange from './DateRange'
import ChangedBy from './ChangedBy'
import TaggedSubject from './TaggedSubject'
import Export from '../../shared/Export'

function Filters({ params, setParams }) {
  const [isFiltered, setIsFiltered] = useState(false)

  useEffect(() => {
    const filtersApplied = [
      'changeType',
      'startOn',
      'endOn',
      'changedById',
      'userId',
      'roleId',
      'permissionId'
    ].some((key) => {
      return params[key] !== ''
    })
    setIsFiltered(filtersApplied)
  }, [
    params.changeType,
    params.startOn,
    params.endOn,
    params.changedById,
    params.userId,
    params.roleId,
    params.permissionId,
    params
  ])

  return (
    <>
      <Card>
        <Card.Body>
          <Row className="g-2 flex-nowrap align-items-center">
            <Col style={{ minWidth: 0 }}>
              <TaggedSubject params={params} setParams={setParams} />
            </Col>
            <Col sm="auto">
              <DateRange params={params} setParams={setParams} />
            </Col>
            <Col sm="auto">
              <select
                value={params.changeType}
                onChange={(e) =>
                  setParams({ ...params, changeType: e.target.value })
                }
                className="form-select"
              >
                <option value="">All Change Types</option>
                <option value="User Master">Users</option>
                <option value="Role Assignment">Role Assignments</option>
                <option value="Role Master">Roles</option>
                <option value="Role Change">Role Permissions</option>
                <option value="Data Access">Data Access</option>
              </select>
            </Col>
            <Col sm="auto">
              <ChangedBy params={params} setParams={setParams} />
            </Col>
            {isFiltered && (
              <Col sm="auto">
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() =>
                    setParams({
                      changeType: '',
                      startOn: '',
                      endOn: '',
                      changedById: '',
                      userId: '',
                      roleId: '',
                      permissionId: ''
                    })
                  }
                >
                  Clear Filters
                </button>
              </Col>
            )}
            <Col sm="auto">
              <Export params={params} source="auditLogs" />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}

export default Filters
